export const CANCEL_INIT_INCIDENT = 'CANCEL_INIT_INCIDENT';
export const CLOSE_DROPDOWN = 'CLOSE_DROPDOWN';
export const INIT_INCIDENT_FLOW_SUCCESS = 'INIT_INCIDENT_FLOW_SUCCESS';
export const INIT_INCIDENT_FLOW_FAILED = 'INIT_INCIDENT_FLOW_FAILED';
export const RESET_FORMS = 'RESET_FORMS';
export const SELECT_TRIGGER_FORM = 'SELECT_TRIGGER_FORM';
export const TOGGLE_FORM_SELECTION_DROPDOWN = 'TOGGLE_FORM_SELECTION_DROPDOWN';

export function cancelInitIncident() {
  return {
    type: CANCEL_INIT_INCIDENT,
  };
}

export function closeDropdown() {
  return {
    type: CLOSE_DROPDOWN,
  };
}

export function selectTriggerForm({ triggerFormId }) {
  return {
    type: SELECT_TRIGGER_FORM,
    payload: { triggerFormId },
  };
}

export function toggleFormSelectionDropdown() {
  return {
    type: TOGGLE_FORM_SELECTION_DROPDOWN,
  };
}

export function resetForms() {
  return {
    type: RESET_FORMS,
  };
}
